// Copyright (c) 2017 Deere & Company

import TcsmSettings from '@deere/cps-it.warranty-model-factory/lib/tcsm-settings';
import actions from '../../actions-list';
import {getDefaultState} from '../state';
import {updateList} from '../../../shared/services/list-selections';

const resetTcsmSettingsFacet = (state, action) =>
    TcsmSettings.update(state, {
        selectedSpaLevels: {
            $set: action.selectedSpaLevels
        }
    });

const toggleSpaLevelsListItems = (state, action) => {

    const selected = state.selectedSpaLevels.length ? [] : action.allowedSpaLevels;

    return TcsmSettings.update(state, {
        selectedSpaLevels: {
            $set: selected
        }
    });

};

const updateSelectedSpaLevelsList = (state, action) =>
    TcsmSettings.update(state, {
        selectedSpaLevels: {
            $set: updateList(
                action.item,
                action.isSelected,
                'key',
                state.selectedSpaLevels
            )
        }
    });

const updateTcsmSettings = (state, action) =>
    TcsmSettings.update(state, {
        $set: action.tcsmSettings
    });

export default (state = getDefaultState().tcsmSettings, action) => {

    const actionTypes = {
        [actions.RESET_TabM_WIP_TCSM_SETTINGS_FACET]: resetTcsmSettingsFacet,
        [actions.TOGGLE_TABM_WIP_SPA_LEVELS_LIST]: toggleSpaLevelsListItems,
        [actions.UPDATE_TABM_WIP_SELECTED_SPA_LEVELS_LIST]: updateSelectedSpaLevelsList,
        [actions.UPDATE_TABM_WIP_TABM_SETTINGS]: updateTcsmSettings
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tabm/wip/reducers/tcsm-settings.js